import React, { useState, useEffect } from "react";
import {
  Form,
  DrawerProps,
  Drawer,
  Row,
  Button,
  Col,
  UploadFile,
  Card,
} from "antd";
import SVGIcon from "../../../../../utils/SVGIcon";
import Config from "../../../../../config/Config";
import AgGridWrapper from "../../../../../components/AgGridWrapper/AgGridWrapper";
import Dragger from "antd/es/upload/Dragger";
import { UploadProps } from "antd/lib";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../utils/hooks/hooks";
import { importFile, setFileRowData, fetchList,verifyFile } from "../../utils/slice";
import { customerAccessCampaignList } from "../../../CustomerAccess/utils/slice";
import { FormBox, InputBox } from "../../../../../components/AntdAddons";
import { validateFields } from "../../../../../config/Global";

import {
  Notification,
  dataToFormDataConverter,
} from "../../../../../config/Global";
import {
  generateImportColumn,
  importErrorFunction,
  renderNA
} from "./../../../../../utils/commonFunctions";
import { assignErrorToInput } from "../../../../../store/api";
import { RootState } from "../../../../../store/app";
import  DownloadIcons from "../../../../../assets/images/icon/downloadIcon.svg?react";
import  UploadIcon from "../../../../../assets/images/icon/uploadIcon.svg?react";
import  Dragicon from "../../../../../assets/images/icon/dragIcon.svg?react";
import columnDefs from "../Listing/importColumnDefs";
interface AddDrawerProps extends DrawerProps {
  titleName: string;
  close: () => void;
}
const ImportComponent: React.FC<AddDrawerProps> = ({
  titleName,
  close,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const setStatusData = useState<any>();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [fileError, setFileError] = useState<boolean>(false);
  const [uploading, setUploading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [showAgGrid, setShowAgGrid] = useState<boolean>(false);
  const [customerAccess, setCustomerAccess] = useState([]);
  const [disabled, setDisabled] = useState<boolean>(true);

  const rowData: any = useAppSelector(
    (state: RootState) => state.user.fileRowdata
  );
  // for display ag-grid when file is uploaded and verified successfully
  const agGridDisplay = showAgGrid ? { display: "block" } : { display: "none" };


  useEffect(() => {
    if (rest?.open && rest.open) {
      setDisabled(true);
      dispatch(customerAccessCampaignList())
        .then((data: any) => {
          setCustomerAccess(data.rows);
          setDisabled(false);
        })
        .catch((error: any) => error);
    }
  }, [rest.open]);



  // const colDefs: any = ;

  const drawerClose = () => {
    setShowAgGrid(false);
    form.resetFields();
    setFileList([]);
    dispatch(setFileRowData(null));
    dispatch(fetchList());
    close();
  };


  // handle form submission
  const handleFormSubmit = (data: any) => {
    if (fileList.length == 0) {
      setFileError(true);
      return 0;
    }
    setFileError(false);
    setUploading(true);
    dispatch(verifyFile(dataToFormDataConverter({ doc_file: fileList[0], campaign_id: data.campaign_id })))
      .then(() => {
        setShowAgGrid(true);
        setUploading(false);
      })
      .catch((error: any) => {
        console.log('error', error?.STATUS);
        setShowAgGrid(false);
        setUploading(false);
        assignErrorToInput(form, error?.STATUS);
      });
  };

  const props: UploadProps = {
    // Removes a file from the file list.
    name: 'doc_file',
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },

    // Sets the file list to contain only the given file and returns false.
    beforeUpload: (file: any) => {
      const allowedExtensions = ['xlsx', 'xls', 'csv'];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        Notification.error({
          message: 'You can only upload Excel/Csv file!',
        })
        setFileList([]);
        return false;
      }
      setFileList([file]);
      return false;
    },
    fileList,
  };

  /**
   * Upload the row data to the server if no errors are found.
   */

  const validateForm = () => {
    validateFields(form, setDisabled);
  };

  // for downloading sample file
  const handleDownload = async () => {
    setDownloading(true);
    const filePath = "/sampleFile/list-of-web-user-invite.xlsx";
    const response = await fetch(filePath);
    const downloadLink = document.createElement("a");
    downloadLink.href = response.url;
    downloadLink.download = "sample_web_user_invitation.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setDownloading(false);
  };

  /**
     * Upload the row data to the server if no errors are found.
     */
    const handleImport = async () => {
      setConfirm(true);
      try {
        dispatch(importFile({ data: rowData?.data })).then((response:any)=>{
          setConfirm(false);
          drawerClose();

        }).catch((error: any) => {
          assignErrorToInput(form, error?.STATUS);
        });
      } catch (error: any) {
        setConfirm(false);
        assignErrorToInput(form, error?.NOTIFICATION);
      }
    };

  return (
    <Drawer
      title={`Import Web ${titleName}`}
      placement="right"
      className="importDrawer"
      width={"90%"}
      onClose={drawerClose}
      destroyOnClose
      closeIcon={<SVGIcon icon="close" color={Config.themePrimaryBtn} />}
      {...rest}
    >
      <FormBox
        form={form}
        id={'inviteForm'}
        onFinish={(handleFormSubmit)}
        onValuesChange={validateForm}
      >
        <Row gutter={[16, 16]} className="importInfoText">
          <Col xs={{ span: 24 }} md={{ span: 18 }}>
            <p>
              Please download a sample file formate,this will help you to create a
              new draft considering what information is required.{" "}
            </p>
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 6 }}>
            <Button
              type="primary"
              onClick={handleDownload}
              loading={downloading}
              style={{ marginTop: 16 }}
            >
              <DownloadIcons />
              {downloading ? "Downloading" : "Download Sample  File"}
            </Button>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xs={{ span: 24 }} md={{ span: 3 }}>
            <Button
              type="primary"
              disabled={fileList.length === 0 || disabled}
              loading={uploading}
              style={{ marginTop: 16 }}
              htmlType="submit"

            >
              <UploadIcon />
              {uploading ? "Uploading" : "Upload and Verify"}
            </Button>
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 9 }} >
            <InputBox.Select
              required
              label="Subscription Name"
              name="campaign_id"
              showSearch
              allowClear
              className="singleSelect"
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              }
              options={{
                list: customerAccess,
                valueKey: "id",
                textKey: "campain_name",
              }}
            />
          </Col>
          <Col xs={{ span: 24 }} md={{ span: 12 }}>
            <Dragger style={{ width: "100%", height: "300px" }} {...props} >
              <p className="ant-upload-drag-icon">
                <Dragicon />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Dragger>
            {fileError && <span>Please select at least one document.</span>}
          </Col>
        </Row>
      </FormBox>
      <div style={agGridDisplay}>
        <div className="ag-theme-quartz">
          <AgGridWrapper
            rowData={rowData?.data?.user || []}
            columnDefs={columnDefs}
            paginationPageSize={10}
            pagination={true}
            // context={{ setStatusData }}
          />
        </div>
        <div style={{ marginTop: 20 }}>
          <Row gutter={16}>
            <Col span={8}>
              <Card
                title="Error"
                bordered={false}
                style={{ background: "#d0312d", color: "white" }}
              >
                {rowData?.error_count ? rowData?.error_count : 0}
              </Card>
            </Col>
            <Col span={8}>
              <Card
                title="Success"
                bordered={false}
                style={{ background: "#3bb143", color: "white" }}
              >
                {rowData?.verified ? rowData?.verified : 0}
              </Card>
            </Col>
            <Col span={8}>
              <Card
                title="Total"
                bordered={false}
                style={{ background: "#29c5f6", color: "white" }}
              >
                {rowData?.total ? rowData?.total : 0}
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <div className="importDrawerBtn">
        <Button
          key="change-order-2"
          htmlType="button"
          className="cancelBtn"
          onClick={drawerClose}
          style={{ marginTop: 16 }}
        >
          Cancel
        </Button>
        {rowData?.error_count === 0 && showAgGrid ? (
          <Button
            type="primary"
            onClick={handleImport}
            loading={confirm}
            style={{ marginTop: 16 }}
          >
            {confirm ? "Uploading" : "Upload "}
          </Button>
        ) : (
          ""
        )}
      </div>
    </Drawer>
  );
};
export default ImportComponent;
UploadIcon;
